import { render, staticRenderFns } from "./Auth0Callback.vue?vue&type=template&id=3c712a1a&"
import script from "./Auth0Callback.vue?vue&type=script&lang=js&"
export * from "./Auth0Callback.vue?vue&type=script&lang=js&"
import style0 from "./Auth0Callback.vue?vue&type=style&index=0&id=3c712a1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports